import moment from 'moment';

/**
 * Récupérer la durée cumulée des créneaux passés en paramètres.
 *
 * @param appointments un tableau de créneaux
 * @return {number} durée totale en minutes
 */
export const getTotalAppointmentsDuration = (appointments) => {
  let appointmentsDurationSum = 0;
  appointments.forEach((appointment) => {
    appointmentsDurationSum += getAppointmentDuration(appointment)
  })
  return appointmentsDurationSum;
}

/**
 * Récupérer la durée en minutes du créneau passé en paramètre.
 * @param appointment le créneau
 * @return {number} durée totale en minutes
 */
export const getAppointmentDuration = (appointment) => {
  let start = moment(appointment.start)
  let endDay = appointment.start.split('T')[0]
  let end = moment(appointment.end)
  return moment.duration(end.diff(start)).asMinutes()
}

/**
 * Vérifier que le créneau à créer n'est pas en chevauchement par rapport aux créneaux existants
 * @param newAppointment le créneau à créer
 * @param existingAppointments les rendez-vous existants
 * @return {boolean} false si il y a chevauchement
 */
export const checkNoAppointmentOverlap = (newAppointment, existingAppointments) => {
  let newAppointmentStart = moment(newAppointment.start)
  let newAppointmentEnd = moment(newAppointment.end)

  return !existingAppointments.some((existingAppointment) => {
    let existingAppointmentStart = moment(existingAppointment.start);
    let existingAppointmentEnd = moment(new Date(existingAppointment.start.split('T')[0] + 'T' + existingAppointment.end));

    return newAppointmentStart.isBefore(existingAppointmentEnd) && newAppointmentEnd.isAfter(existingAppointmentStart);
  });
}

/**
 * Vérifier que le créneau à créer est dans les horaires d'ouverture du bureau
 * @param newAppointment le créneau à créer
 * @param businessHours les horaires d'ouverture du bureau (au format FullCalendar)
 * @return {boolean} false si le créneau est en dehors des créneaux d'ouverture
 */
export const appointmentInBusinessHours = (newAppointment, businessHours) => {
  let isValid = false;
  let appointmentDayNumber = newAppointment.day.getDay();

  let businessHoursByDay = businessHours.filter(bh => {
    return bh.daysOfWeek.includes(appointmentDayNumber)
  })

  for (let bh of businessHoursByDay) {
    let businessHoursStart = new Date(newAppointment.day.setHours(bh.startTime.split(':')[0], bh.startTime.split(':')[1], 0, 0))
    let businessHoursEnd = new Date(newAppointment.day.setHours(bh.endTime.split(':')[0], bh.endTime.split(':')[1], 0, 0))

    if (moment(newAppointment.start).isSameOrAfter(moment(businessHoursStart)) &&
      moment(newAppointment.end).isSameOrBefore(moment(businessHoursEnd))) {
      isValid = true;
    }
  }
  return isValid;
}

